<template>
  <tela-component title="Relatório Financeiro">
    <v-card flat rounded="lg">
      <v-card-text>
        <v-form ref="form">
          <!--<v-text-field
            label="Data inicial"
            type="date"
            v-model="filtro.dtini"
          ></v-text-field>
          <v-text-field
            label="Data final"
            type="date"
            v-model="filtro.dtfim"
          ></v-text-field>-->
          <v-row dense>
            <v-col>
              <selecionar-vendedor-relat />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-select
                label="Tipo de listagem"
                :items="tiposListagem"
                item-value="cod"
                item-text="desc"
                v-model="filtro.tiporelat"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                label="Vencidos há mais de"
                suffix="dias"
                v-mask="'###'"
                v-model="filtro.diasvencidos"
                v-if="filtro.tiporelat == 2"
              ></v-text-field>
              <v-text-field
                label="Com vencimento a partir de"
                type="date"
                v-model="filtro.vctoapartirde"
                v-else-if="filtro.tiporelat == 3"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn block color="info" rounded depressed @click="gerarRelatorio()"
            >Gerar relatório</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import moment from "moment";
import TelaComponent from "../tela/TelaComponent.vue";
import { mapState } from "vuex";
import SelecionarVendedorRelat from "./SelecionarVendedorRelat.vue";
export default {
  components: { TelaComponent, SelecionarVendedorRelat },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("relatorios", ["vendedorSelecionado"]),
  },
  data: () => ({
    filtro: {
      dtini: moment().format("YYYY-MM-DD"),
      dtfim: moment().add(15, "d").format("YYYY-MM-DD"),
      tiporelat: 1,
      diasvencidos: 0,
      vctoapartirde: moment().format("YYYY-MM-DD"),
    },
    tiposListagem: [
      { cod: 1, desc: "Geral" },
      { cod: 2, desc: "Títulos vencidos" },
      { cod: 3, desc: "Títulos a vencer" },
    ],
  }),
  methods: {
    gerarRelatorio() {
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/nutricao-animal/relatorios/financeiro?token=${
          this.usuarioLogado.token
        }
        &tiporelat=${this.filtro.tiporelat}
        &diasvencidos=${this.filtro.diasvencidos}
        &vctoapartirde=${moment(this.filtro.vctoapartirde).format(
          "DD-MM-YYYY"
        )}&codvendedor=${this.vendedorSelecionado}`,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>